<app-title-section></app-title-section>

<div class="card p-1"  style="margin-left: 15px; margin-right: 15px ; height: 100vh">
    <!-- Tabs -->
    <div class=" retour" (click)="retour()" style="margin-bottom: 15px ; margin-left: 23px; margin-top: 10px; width: 200px">
        <i style="font-size: 20px; ">←</i>
        <strong>Retour</strong>
    </div>
    <ul class="nav nav-tabs m-0  " style=" border-bottom: 1px solid #eee; ">
        <li class="nav-item">
            <a style=" font-size: 15px"
                    class="nav-link"
                    [routerLink]="['etat']"
                    [queryParams]="{ entrepot_id: warehouseId }"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    href="javascript:void(0)"
            >
                Etat de stock
            </a>
        </li>
        <li class="nav-item">
            <a style=" font-size: 15px"
                    class="nav-link"
                    [routerLink]="['apercu']"
                    [queryParams]="{ entrepot_id: warehouseId }"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    href="javascript:void(0)"
            >
                Aperçu
            </a>
        </li>

    </ul>

    <router-outlet style="margin-top: 24px"></router-outlet>
</div>
